module.exports = __webpack_public_path__ + "img/gq.81061918.jpg";